import EMBEDDED_END_USER_TOKEN_STORAGE_KEY from './embeddedEndUserTokenStorageKey.js';

const clearEmbeddedEndUserToken = () => {
  try {
    sessionStorage.removeItem(EMBEDDED_END_USER_TOKEN_STORAGE_KEY);
  } catch {
    /* restricted storage */
  }
};

export default clearEmbeddedEndUserToken;
